import React from 'react';
import { SchematicShell } from './SchematicPrimitives';

/**
 * Torchiere floor lamp elevation (pairs with dormFloorLampRenderer).
 *
 * The renderer stacks base disc -> thin pole -> upward-flaring bowl shade.
 * Drawn as a plain rectangle it read as a wardrobe: at 10x10x72 the bounding
 * box is a tall column, which is exactly the wrong silhouette. Constants are
 * kept in step with the renderer's.
 */
const IN = 0.0254;

const BASE_DIAMETER = 8 * IN;
const BASE_H = 1.25 * IN;
const POLE_DIAMETER = 0.75 * IN;
const SHADE_BOTTOM_DIAMETER = 2.6 * IN;
const SHADE_TOP_DIAMETER = 9.5 * IN;
const SHADE_H = 4.5 * IN;

export function DormFloorLampSchematic({
  widthMeters: width,
  heightMeters: height,
  strokeColor,
  strokeWidth,
}) {
  const cx = width / 2;
  // Clamp every horizontal extent to the object's own width so a narrower
  // lamp than the catalog's 10" never draws outside its box.
  const half = (d) => Math.min(d, width) / 2;

  const shadeTop = 0;
  const shadeBottomY = SHADE_H;
  const baseTopY = height - BASE_H;

  const shadeTopHalf = half(SHADE_TOP_DIAMETER);
  const shadeBotHalf = half(SHADE_BOTTOM_DIAMETER);
  const poleHalf = half(POLE_DIAMETER);
  const baseHalf = half(BASE_DIAMETER);

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      drawFrame={false}
    >
      {/* Bowl shade — wider at the top, open upward */}
      <path
        d={`M ${cx - shadeTopHalf} ${shadeTop} L ${cx + shadeTopHalf} ${shadeTop} L ${cx + shadeBotHalf} ${shadeBottomY} L ${cx - shadeBotHalf} ${shadeBottomY} Z`}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      {/* Pole */}
      <rect
        x={cx - poleHalf}
        y={shadeBottomY}
        width={poleHalf * 2}
        height={Math.max(0, baseTopY - shadeBottomY)}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Weighted base */}
      <rect
        x={cx - baseHalf}
        y={baseTopY}
        width={baseHalf * 2}
        height={BASE_H}
        fill={strokeColor}
        fillOpacity={0.12}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    </SchematicShell>
  );
}
